import { AdminLayout, WebLayout } from "#layouts";
import React from "react";
import {
  CropProtectionDetailComponent,
  SeedDetailComponent,
} from "#components";
import useGet from "#hooks/useGet.js";
import ENDPOINTS from "#services/endPoints.js";
import QUERY_KEYS from "#services/queryKeys.js";
import ImagesUrl from "#constants/images.js";
import PlacementListingDetail from "../../../components/cropPlan/cropPlanDetail/placementListingDetail";
import globalConfig from "#constants/globalConfig.js";
import { useNavigate } from "react-router-dom";
import { NotFound } from "#UI";

const CropPlanDetail = () => {
  const selectedSeasonId = localStorage.getItem(globalConfig.ADMIN_SEASON_ID);

  const { data: cropPlanDetail } = useGet(
    ENDPOINTS.CROP_PLAN_DETAIL,
    QUERY_KEYS.CROP_PLAN_DETAIL_QUERY_KEY,
    {
      seasonId: selectedSeasonId,
    }
  );
  const cropPlanDetailData = cropPlanDetail?.data;
  const nav = useNavigate();
  return (
    <AdminLayout>
      <section className="main-section spacer">
        {/* <div className="d-flex justify-content-end">
          <button
            className="primary-btn"
            onClick={() => nav(AdminRoutePath?.EDIT_CROP_PLAN_MANAGEMENT?.path)}
          >
            Edit
          </button>
        </div> */}
        <div className="container">
          <div className="flex_wrap_container">
            {cropPlanDetailData?.cropPlanList?.length > 0 ? (
              cropPlanDetailData?.cropPlanList?.map((item, parentIndex) => {
                const isEvenIndex = parentIndex % 2 === 0;
                return (
                  <div
                    className="row flex_inner_box border_primary d-flex flex-column gap-3 pb-3"
                    style={{
                      background: isEvenIndex
                        ? "rgba(218, 242, 186, 1)"
                        : "rgba(224, 224, 224, 1)",
                    }}
                  >
                    <div className="col-12">
                      <div className="d-flex justify-content-between align-items-center gap-3 mb-4">
                        <div className="add_crop_wrapper_card mb-0">
                          <form>
                            <div className="row justify-content-between gy-3 gx-5">
                              <div className="col-xl-12">
                                <div className="top-detail d-flex justify-content-between align-items-center gap-3 mb-2">
                                  <h2 className="h4 text-black mb-0">
                                    {item?.cropName}
                                  </h2>
                                </div>
                                <div className="common-statistics">
                                  <div className="common-info-detail">
                                    <h2 className="h4 text-black text-wrap">
                                      {item?.description}
                                    </h2>
                                  </div>

                                  {/* {item?.fieldData.length === 0 ? (
                                  <div className="common-info-detail">
                                    <h2 className="h4 text-black">Acres</h2>
                                    <p className="mb-0">{item?.fieldArea}</p>
                                  </div>
                                ) : (  <div class="top-detail d-flex justify-content-between align-items-center gap-3 mb-2">
                                    <h2 class="h4 text-black mb-0">
                                      Field Name
                                    </h2>
                                  </div>
                                  item?.fieldData?.map((data, i) => {
                                    return (
                                      <div className="field_detail_container">
                                        <div
                                          className="common-info-detail"
                                          key={i}
                                        >
                                          <h2 className="h4 text-black">
                                            Field
                                          </h2>
                                          <p className="mb-0">{data?.name}</p>
                                        </div>
                                        <div
                                          className="common-info-detail"
                                          key={i}
                                        >
                                          <h2 className="h4 text-black">
                                            Acres
                                          </h2>
                                          <p className="mb-0">{data?.area}</p>
                                        </div>
                                      </div>
                                    );]
                                  })
                                )} */}
                                  {item?.fieldData.length === 0 ? (
                                    <div className="common-info-detail">
                                      <h2 className="h4 text-black fw-bold">
                                        Acres
                                      </h2>
                                      <p className="mb-0 fw-bold">
                                        {item?.fieldArea}
                                      </p>
                                    </div>
                                  ) : (
                                    <>
                                      <div className="border-bottom pb-2 d-flex justify-content-between align-items-center gap-3 mb-2">
                                        <h2 className="h4 text-black mb-0">
                                          Field Name
                                        </h2>
                                        <h2 className="h4 text-black mb-0">
                                          Acres
                                        </h2>
                                      </div>
                                      {item?.fieldData?.map((data, i) => (
                                        <div className="" key={i}>
                                          <div className="common-info-detail">
                                            <p>{data?.name}</p>
                                            <p className="mb-0">{data?.area}</p>
                                          </div>
                                        </div>
                                      ))}
                                    </>
                                  )}
                                  {item?.fieldData.length === 0 ? null : (
                                    <div className="common-info-detail">
                                      <p className="h4 text-black mt-2 fw-bold">
                                        Total Acres
                                      </p>
                                      <p className="mb-0 fw-bold mt-2">
                                        {item?.fieldData
                                          ?.map(
                                            (field) => Number(field.area) || 0
                                          ) // Convert to number, avoid NaN
                                          .reduce(
                                            (total, num) => total + num,
                                            0
                                          ) ?? "N/A"}
                                      </p>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="custom_accordion_item">
                        <button
                          className="custom_accordion d-flex w-100 justify-content-between align-items-center border-0"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapseCrop_1${parentIndex}`}
                          aria-expanded="false"
                          aria-controls={`collapseCrop_1${parentIndex}`}
                        >
                          <p className="m-0 fertility_text"> Fertility</p>
                          <span className="drop_icon">
                            <img
                              className="drop_icon"
                              src={ImagesUrl.dopeIcon}
                              alt="drop-icon .."
                            />
                          </span>
                        </button>
                        <div
                          className="custom_collapse_body collapse"
                          id={`collapseCrop_1${parentIndex}`}
                        >
                          <div className="d-flex gap-4 align-items-center soil-test-warper ">
                            <p className="mb-0">Soil Test</p>
                            <div className="inline_input">
                              {`${item?.soilData?.nitrogen || 0}-${
                                item?.soilData?.phosphorus || 0
                              }-${item?.soilData?.potassium || 0}-${
                                item?.soilData?.other || 0
                              }`}
                            </div>
                          </div>
                          <div className="d-flex align-items-center justify-content-between pt-4 px-4 ">
                            <p className="fs-5 fw-medium mb-0">Fertilizer</p>
                          </div>
                          <PlacementListingDetail data={item?.fertility} />
                          <div className="placement_overall_info">
                            <div className="placement_overall_item">
                              <span className="crop-plan-detail">
                                Total Fertilizer Nutrients{" "}
                              </span>
                              <span className="crop-plan-detail">
                                {item?.totalFertilizerNutrients}
                              </span>
                            </div>
                            <div className="placement_overall_item">
                              <span className="crop-plan-detail">
                                Total Nutrients{" "}
                              </span>
                              <span className="crop-plan-detail">
                                {item.totalNutrients}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <SeedDetailComponent
                        SeedDetailData={item?.seedData}
                        parentIndex={parentIndex}
                      />
                    </div>
                    <div className="col-lg-12">
                      <CropProtectionDetailComponent
                        CropProtectionDetailData={item?.cropProtection}
                        parentIndex={parentIndex}
                      />
                    </div>
                  </div>
                );
              })
            ) : (
              <NotFound />
            )}
          </div>
        </div>
      </section>
    </AdminLayout>
  );
};

export default CropPlanDetail;
